export default "__VITE_ASSET__272714d1__"